
import type { PropType } from 'vue'

import type { ClusterFeatureEntity } from '@/modules/DispatcherWorkplaceModule/types'
import type { ClusterFeature } from '@/modules/YandexMap3Module/map-cluster.types'

import { defineComponent, onMounted, ref } from 'vue'

import DwClusterPopupGroupFeature from './GroupFeature.vue'

export default defineComponent({
    components: {
        'dw-cluster-popup-group-feature': DwClusterPopupGroupFeature
    },
    props: {
        features: {
            type: Array as PropType<Array<ClusterFeature<ClusterFeatureEntity>>>,
            default: () => []
        },
        isCourierItem: {
            type: Boolean,
            default: false,
        }
    },
    emits: ['select', 'close'],
    setup(props, { emit }) {
        const onSelect = (feature: ClusterFeature<ClusterFeatureEntity>, feature_index: number) => {
            emit('select', {
                feature,
                feature_index
            })
        }

        const onClose = () => {
            emit('close')
        }

        return {
            onSelect,
            onClose,
        }
    }
})
